import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ColDef, GridApi, ICellRendererParams, IHeaderParams, IRowNode } from 'ag-grid-community';
import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CyberSecurityOrgService } from '@pt/api-client';
import { UpdateAppAuditCveRequest } from 'it/primatoo/openapi/api/org/schemas/cybersecurity/UpdateAppAuditCveRequest';
import { CVEUpdate } from 'it/primatoo/openapi/api/org/schemas/cybersecurity/_updateappauditcverequest/CVEUpdate';
import { CVEAudit } from 'it/primatoo/openapi/api/org/schemas/cybersecurity/_appauditcve/CVEAudit';
import {
  CVEConfigUpdate
} from 'it/primatoo/openapi/api/org/schemas/cybersecurity/_updateappauditcverequest/_cveupdate/CVEConfigUpdate';
import { UpdateAppAuditCveResponse } from 'it/primatoo/openapi/api/org/schemas/cybersecurity/UpdateAppAuditCveResponse';
import { IoniconsOutline } from '@pt/pt-models';
import { CVEConfig } from 'it/primatoo/openapi/api/org/schemas/cybersecurity/_appauditcve/_cveaudit/CVEConfig';

@Component({
  selector: 'pt-cve-details-renderer',
  template: `
    <div class="cve-details-renderer-container" (click)="$event.stopPropagation()" *ngIf="currentNode?.data">
      <div class="summary">
        <label class="mb-1">{{ summaryHeaderName }}</label>
        <div class="text-summary">{{ currentNode?.data?.summary }}</div>
      </div>
      <div class="form">
        <form [formGroup]="formGroup">
          <div class="form-row-container">
            <div class="cve-select-container">
              <div class="form-check d-flex align-items-center">
                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault"
                       formControlName="suppressed">
                <label class="form-check-label ms-1" for="flexSwitchCheckDefault">{{ suppressedHeaderName }}</label>
              </div>
            </div>

            <ng-template #popContent>
              <table class="table table-sm table-striped" *ngIf="currentNode?.data?.auditRID">
                <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ 'LABELS.VALUE' | translate }}</th>
                  <th scope="col">{{ 'LABELS.DEFAULT' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  [ngClass]="{'bg-warning': currentNode.data?.auditRID?.confidentialityViolation !== currentNode.data?.defaultRID?.confidentialityViolation}">
                  <td class="font-12">
                    {{ getHeaderName('confidentialityViolation') }}
                  </td>
                  <td class="font-12 text-center">{{ getLabel(currentNode.data.auditRID.confidentialityViolation) }}
                  </td>
                  <td class="font-12 text-center">{{ getLabel(currentNode.data.defaultRID.confidentialityViolation) }}
                  </td>
                </tr>

                <tr
                  [ngClass]="{'bg-warning': currentNode.data.auditRID.integrityCompromise !== currentNode.data.defaultRID.integrityCompromise}">
                  <td class="font-12">
                    {{ getHeaderName('integrityCompromise') }}
                  </td>
                  <td class="font-12 text-center">
                    {{ getLabel(currentNode.data.auditRID.integrityCompromise) }}
                  </td>
                  <td class="font-12 text-center">
                    {{ getLabel(currentNode.data.defaultRID.integrityCompromise) }}
                  </td>
                </tr>

                <tr
                  [ngClass]="{'bg-warning': currentNode.data.auditRID.availabilityLoss !== currentNode.data.defaultRID.availabilityLoss}">
                  <td class="font-12 ">
                    {{ getHeaderName('availabilityLoss') }}
                  </td>
                  <td class="font-12 text-center">{{ getLabel(currentNode.data.auditRID.availabilityLoss) }}
                  </td>
                  <td class="font-12 text-center">{{ getLabel(currentNode.data.defaultRID.availabilityLoss) }}</td>
                </tr>
                <!-- Add more rows here -->
                </tbody>
              </table>

            </ng-template>

            <button (click)="resetDefaultValue()"
                    [ngbPopover]="popContent"
                    [disabled]="disableReset"
                    popoverClass="customPopover"
                    triggers="hover"
                    container="body"
                    class="btn btn-link btn-sm ms-0 font-12"
                    style="padding: 0; text-decoration: underline;">
              {{ "BUTTON.RESET_DEFAULT_VALUE" | translate }}
            </button>
          </div>

          <div class="form-row-container">
            <div class="cve-select-container" *ngFor="let key of columnsFields; last as isLast"
                 [ngClass]="{'m-0': isLast}">
              <label class="mb-1">{{ getHeaderName(key) }}</label>
              <!--                appendTo="body"-->
              <ng-select
                class="cve-select"
                [items]="threatEval"
                [bindValue]="'value'"
                [bindLabel]="'label'"
                [searchable]='false'
                [clearable]='false'
                [ngClass]="{'m-0': isLast}"
                formControlName="{{key}}">
              </ng-select>
              <!--              && formGroup.controls[key].invalid, 'valid': formGroup.controls[key].touched && formGroup.controls[key].valid-->
            </div>
          </div>


          <!--          cvePresent  = true   e matches == null-->
          <ng-container
            *ngIf="!(currentNode.data.cvePresent && (currentNode.data.matches === null || currentNode.data.matches?.length === 0))">
            <div class="form-row-container" style="margin-top: 20px;">
              <div>
                <div class="d-flex align-items-center">
                  <span>Vulnerabilità dipendente da configurazioni</span>
                  <pt-icon
                    [key]='IconWarning'
                    *ngIf="currentNode.data.missingMatch"
                    class="text-warning">
                  </pt-icon>
                  <div style="margin-left: 5px;"
                       *ngIf="currentNode.data.cvePresent === true"
                       [ngClass]=" 'text-danger'">
                    Presente
                  </div>

                  <div style="margin-left: 5px;"
                       *ngIf="currentNode.data.cvePresent === false && currentNode.data.cvePresent !== null"
                       [ngClass]=" 'text-success'">
                    Non presente
                  </div>

                  <!--                  <div style="margin-left: 5px;"-->
                  <!--                       [ngClass]="currentNode.data.cvePresent ? 'text-danger' : 'text-success'">-->
                  <!--                    {{currentNode.data.cvePresent === true ? 'Prensente' : 'Non presente'}}-->
                  <!--                  </div>-->
                </div>
                <div style="margin-bottom: 5px; white-space: wrap; color: grey;">
                  Indicare quali applicativi/componenti sono coinvolti per stabilire la presenza o meno della
                  vulnerabilità:
                </div>
              </div>
            </div>

            <div class="form-row-container" *ngIf="currentNode?.data?.matches?.length > 0">
              <pt-cve-details-table
                class="display-contents"
                [readonly]="disableCveDetails"
                (updateAppAuditCve)="updateAppAuditCve($event)"
                [cveConfig]="currentNode.data.matches">
              </pt-cve-details-table>
            </div>
          </ng-container>
        </form>
      </div>
    </div>
  `,
  styles: [`


    .customPopover {
      font-size: 12px !important;
    }

    .customPopover .popover-body {
      padding: 5px 10px !important;
    }

    .cve-details-renderer-container {
      display: flex;
      flex-direction: row;
      width: 100%;
      padding: 15px 20px;
      background: #acd7fa55;
    }

    .cve-details-renderer-container .summary {
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      /*background: green;*/
      display: flex;
      flex-direction: column;
      margin-right: 10px;

      background: white;
      border: 1px solid #33333333;
      padding: 15px;
    }

    .cve-details-renderer-container .summary .text-summary {
      text-wrap: wrap;
      overflow-y: auto;
      height: 260px;
      background: #ffffff;
      padding: 5px 8px;
    }

    .cve-details-renderer-container .form {
      width: 495px;
      /*height: 180px;*/
      display: flex;
      border: 1px solid #dfdbdb;
      padding: 10px;
      background: white;
    }

    .cve-suppressed {
      display: inline-flex;
      flex-direction: column;
      margin-right: 10px;
    }

    .cve-suppressed div {
      height: 25px;
      display: flex;
      align-items: baseline;
    }

    .cve-summary {
      display: inline-flex;
      flex-direction: column;
      width: calc(100% - 150px - 150px - 150px - 100px - 79px);
      padding: 0 10px;

    }

    .cve-summary div {
      height: 25px;
      display: flex;
      width: 100%;
      align-items: baseline;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }


    .cve-details-renderer-container .btn-save {
      border-radius: 0;
      height: 25px;
      margin-top: 8px;
    }

    .cve-details-renderer-container .adr-body {
      display: flex;
      font-size: 12px;
      height: 100px;
      overflow-y: auto;
      align-items: flex-start;
      padding: 4px;
      flex-direction: column;
    }

    .cve-details-renderer-container .adr-body .row-summary {
      display: flex;
      flex-direction: column;
      margin-bottom: 15px;
      width: 100%;
    }

    .overflow-y-auto {
      overflow-y: auto;
    }


    .cve-details-renderer-container .adr-body form {
      display: flex;
      width: 100%;
      align-items: flex-end;
      justify-content: flex-start;
    }

    .cve-details-renderer-container .adr-footer {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 25px;
      justify-content: flex-end;
      margin: 10px 0;
    }

    .form-row-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .cve-select-container {
      display: inline-flex;
      flex-direction: column;
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      margin-right: 10px;
    }

    .cve-select-container .cve-select {
      width: 100%;
      height: 25px;
      display: inline-flex;
    }

    .cve-select-container .cve-select .ng-select-container {
      min-height: 25px !important;
      height: 25px !important;
    }

    .invalid .ng-select .ng-select-container {
      border-color: red !important;
    }

    .valid .ng-select .ng-select-container {
      border-color: green !important;
    }

  `],
  encapsulation: ViewEncapsulation.None
})
export class CveDetailsRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp, OnDestroy {
  params: any;
  // value?: CVEAudit;
  threatEval: CVESelect[];
  formGroup = new FormGroup({
    integrityCompromise: new FormControl(null, [Validators.required, Validators.min(1)]),
    confidentialityViolation: new FormControl(null, [Validators.required, Validators.min(1)]),
    availabilityLoss: new FormControl(null, [Validators.required, Validators.min(1)]),
    suppressed: new FormControl(false)
  });

  public loading = false;

  public suppressedHeaderName = 'Suppressed';
  public summaryHeaderName = 'Summary';
  public colDef: ColDef[] = [];
  public columnsFields: string[] = ['integrityCompromise', 'confidentialityViolation', 'availabilityLoss', 'suppressed', 'summary'];
  public currentNode?: IRowNode<CVEAudit>;
  private gridApi?: GridApi;
  private destroyRequest$ = new Subject<boolean>();
  public disableReset = false;
  public disableCveDetails = false;
  private applicationId?: number;
  private isChanged: () => {};
  public IconWarning = IoniconsOutline.warning;
  private localCveAudit: CVEConfig[] = [];

  constructor(private cyberSecurityOrgService: CyberSecurityOrgService) {
  }

  public getLabel(key: number): string {
    let label = 'ND';
    this.threatEval.forEach(t => {
      if (key === t.value) {
        label = t.label;
      }
    });
    return label;
  }

  public getHeaderName(field: string): string {
    const colDef = this.colDef?.find(c => c.field === field);
    if (colDef) {
      return colDef.headerName;
    }
    return 'ND';
  }

  agInit(params: any): void {
    this.params = params;
    this.loadConfigurations();
    if (this.currentNode) {
      this.formGroup.setValue({
        integrityCompromise: this.currentNode.data.auditRID.integrityCompromise,
        confidentialityViolation: this.currentNode.data.auditRID.confidentialityViolation,
        availabilityLoss: this.currentNode.data.auditRID.availabilityLoss,
        suppressed: this.currentNode.data.suppressed || false
      });
      this.formGroup.markAsUntouched();

      this.disableCveDetails = this.currentNode.data.suppressed;
      if (this.currentNode.data.suppressed || !this.currentNode.data.cvePresent) {
        this.disableReset = true;
        this.formGroup.controls.integrityCompromise.disable();
        this.formGroup.controls.confidentialityViolation.disable();
        this.formGroup.controls.availabilityLoss.disable();
        // call 24 con pietro non serve bloccare soppressed
        // if (!this.currentNode.data.cvePresent) {
        //   this.formGroup.controls.suppressed.disable();
        // }
      } else {
        this.disableReset = false;
        this.formGroup.controls.integrityCompromise.enable();
        this.formGroup.controls.confidentialityViolation.enable();
        this.formGroup.controls.availabilityLoss.enable();
      }
      this.destroyRequest$.next(true);

      this.formGroup.valueChanges.pipe(
        takeUntil(this.destroyRequest$)
      ).subscribe((v) => {
        this.save();
      });

    } else {
      this.formGroup.reset();
    }
  }

  refresh(params: ICellRendererParams): boolean;

  refresh(params: IHeaderParams): boolean;

  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }

  save() {
    const integrityCompromise = this.formGroup.controls.integrityCompromise.value;
    const confidentialityViolation = this.formGroup.controls.confidentialityViolation.value;
    const availabilityLoss = this.formGroup.controls.availabilityLoss.value;
    const suppressed = this.formGroup.controls.suppressed.value;

    const matches: Array<CVEConfigUpdate> = [];
    this.localCveAudit.forEach(m => {
      matches.push({
        uuid: m.uuid,
        present: m.present
      });
    });

    if (this.applicationId && this.gridApi && this.currentNode) {
      const cves: CVEUpdate[] = [{
        id: this.currentNode.data.id,
        name: this.currentNode.data.name,
        suppressed: suppressed,
        auditRID: {
          confidentialityViolation: confidentialityViolation,
          integrityCompromise: integrityCompromise,
          availabilityLoss: availabilityLoss
        },
        matches
      }];

      this.currentNode.data.auditRID.confidentialityViolation = confidentialityViolation;
      this.currentNode.data.auditRID.integrityCompromise = integrityCompromise;
      this.currentNode.data.auditRID.availabilityLoss = availabilityLoss;
      this.currentNode.data.suppressed = suppressed;

      const request: UpdateAppAuditCveRequest = {
        cves
      };
      this.cyberSecurityOrgService.patchAppAuditCve(this.applicationId, request)
        .pipe(takeUntil(this.destroyRequest$))
        .subscribe((response: UpdateAppAuditCveResponse) => {
          this.isChanged();
          if (response.matchesResult.length === 1) {
            const matchesResponse = response.matchesResult[0];
            this.currentNode.data.cvePresent = matchesResponse.cvePresent;
            this.currentNode.data.missingMatch = matchesResponse.missingMatch;
            this.currentNode.data.matches = this.currentNode.data.matches.map(m => {
              const merge = matches.find(mm => mm.uuid === m.uuid);
              if (merge) {
                return { ...m, present: merge.present } as CVEConfig;
              }
              return { ...m } as CVEConfig;
            });

            this.gridApi.applyTransaction({ update: [this.currentNode.data] });
            // this.reloadThreats();
          } else {
            console.error('Invalid response');
          }


        }, () => {
          // this.gridApi.forEachNode((n) => {
          //   if (n.expanded) {
          //     n.setExpanded(false);
          //   }
          // })
          // this.reloadThreats();
        });
    }
  }

  resetDefaultValue() {
    this.formGroup.controls.integrityCompromise.setValue(this.currentNode.data.defaultRID.integrityCompromise, { emitEvent: false });
    this.formGroup.controls.confidentialityViolation.setValue(this.currentNode.data.defaultRID.confidentialityViolation, { emitEvent: false });
    this.formGroup.controls.availabilityLoss.setValue(this.currentNode.data.defaultRID.availabilityLoss, { emitEvent: false });
    this.save();
  }

  ngOnDestroy(): void {
    this.destroyRequest$.next(true);
  }

  private loadConfigurations() {
    this.gridApi = this.params.api;
    const context = this.params.context; // qui va messa la mappatura salvata in threatEval
    this.isChanged = context.isChanged;
    this.applicationId = context.applicationId;
    if (!this.applicationId) {
      console.error('Invalid configuration cve-details-renderer. Missing context.applicationId');
    }
    this.threatEval = context.threatEval;
    if (!this.threatEval) {
      console.error('Invalid configuration cve-details-renderer. Missing context.threatEval');
    }
    this.columnsFields = context.columnsFields;
    if (!this.columnsFields) {
      console.error('Invalid configuration cve-details-renderer. Missing context.columnsFields');
    }
    this.currentNode = this.params.node;

    this.gridApi.forEachNode((n) => {
      if (n.expanded && n.data.id !== this.currentNode.data.id) {
        n.setExpanded(false);
      }
    });

    this.localCveAudit = this.currentNode.data.matches;
    this.colDef = [];
    this.params.api.getColumnDefs().forEach((colDef: ColDef) => {
      if (this.columnsFields.includes(colDef.field)) {
        this.colDef.push(colDef);
      }
      if (colDef.field === 'suppressed') {
        this.suppressedHeaderName = colDef.headerName;
      }
      if (colDef.field === 'summary') {
        this.summaryHeaderName = colDef.headerName;
      }
    });
  }

  updateAppAuditCve($event: CVEConfig[]) {
    this.localCveAudit = $event;
    this.save();
  }
}


export interface CVESelect {
  value: number;
  label: string;
}
